import React from 'react'
import logo from '../../../assets/logo/logo_negative.png'
import styles from './Logo.module.scss'

const Logo: React.FC = () => {
  return (
    <div className={styles.logoWrapper}>
      <img src={logo} alt="Logo" className={styles.logo} />
      <h1 className={styles.title}>LanguageGuessr</h1>
    </div>
  )
}

export default Logo
